// extracted by mini-css-extract-plugin
export var imageContainer = "technology-module--imageContainer--d2102";
export var technologyContainer = "technology-module--technologyContainer--7b4fd";
export var textContainer = "technology-module--textContainer--0f39f";